import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {Body} from 'shells/typography/body';

import styles from './clicked-url-filter-feature-gate.module.css';

type Props = {
    isAdmin: boolean;
};

export function ClickedUrlFilterFeatureGate(props: Props) {
    const {isAdmin} = props;
    const [isOpen, setIsOpen] = React.useState(false);
    const menuRef = React.useRef<HTMLDivElement | null>(null);

    // Only close the menu for clicks outside of it, else the link isn't consistently clickable
    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const CustomMenu = () => {
        return (
            <div ref={menuRef} className={styles['menu-styles']}>
                <StackLegacy spacing={16}>
                    <Body size='small' isBold={true}>
                        See who clicked on which links
                    </Body>
                    <Body size='small'>
                        {isAdmin ? 'Upgrade ' : 'Ask your administrator to upgrade '}to Marketing
                        Pro to see a link-by-link breakdown of who clicked on which links.
                    </Body>
                    {isAdmin && (
                        <Link
                            variant='primary'
                            // @ts-expect-error
                            as={RoutedLink}
                            to='/setup/billing/sales'
                            size='small'
                        >
                            View billing
                        </Link>
                    )}
                </StackLegacy>
            </div>
        );
    };

    return (
        <SelectPickerGeneric
            options={[]}
            value={{value: 'any', label: 'Any link'}}
            styles={{
                // @ts-expect-error
                control: (base) => ({
                    ...base,
                    zIndex: 10,
                    minWidth: 200,
                    height: 31,
                    minHeight: 31,
                }),
            }}
            onChange={() => {}}
            components={{
                Menu: CustomMenu,
            }}
            menuIsOpen={isOpen}
            onMenuOpen={() => setIsOpen(true)}
            onMenuClose={() => {}} // Prevent default close behavior
            rightContent={{
                getSelectedValueContent: () => (
                    <div className='flex align-center'>
                        <UpgradeArrowIcon size={20} wrapWithDiv={false} color={colors.blue} />
                    </div>
                ),
            }}
        />
    );
}
